import styled from 'styled-components';
export const ConvertedOn = styled.div`
  font-size: 0.75rem;
  color: #666666;
  padding-bottom: 1rem;
`;